export class DataFlowModulePack {
  public Description: string;

  public Lookup: string;

  public Name: string;

  public Toolkit: string;
}
